import { render, staticRenderFns } from "./ClassificationInvoices.vue?vue&type=template&id=3948fb8d&scoped=true&"
import script from "./ClassificationInvoices.vue?vue&type=script&lang=js&"
export * from "./ClassificationInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationInvoices.vue?vue&type=style&index=0&id=3948fb8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948fb8d",
  null
  
)

export default component.exports